import * as React from 'react';
import {
  Edit,
  required,
  SimpleForm,
  TextInput,
  TextField,
  ReferenceField,
  SaveButton,
  DeleteButton,
  Toolbar,
  CheckboxGroupInput,
  DateInput,
  maxLength,
} from 'react-admin';
import TimeInput from '../components/TimeInput';
import {makeStyles} from '@material-ui/core/styles';

export const styles = {
  inline: {display: 'inline-block', marginLeft: 32},
  margin: {marginLeft: 32, marginRight: 32},
};

const validateDescription = [maxLength(10000), required()];

const useStyles = makeStyles(styles);

const redirect = (basePath, id, data) =>
  `/courts/${data.courtId}/unavailability`;

const CustomToolbar = (props) => {
  return (
    <Toolbar
      {...props}
      classes={useStyles()}
      style={{justifyContent: 'space-between'}}>
      <SaveButton />
      <DeleteButton
        undoable={false}
        redirect={`/courts/${props.record.courtId}/unavailability`}
      />
    </Toolbar>
  );
};

const UnavailabilityTitle = ({record}) => {
  return record ? <span>Unavailability</span> : null;
};

const UnavailabilityEdit = (props) => {
  const classes = useStyles();
  return (
    <Edit title={<UnavailabilityTitle />} {...props}>
      <SimpleForm redirect={redirect} toolbar={<CustomToolbar />}>
        <ReferenceField
          source='courtId'
          reference='courts'
          formClassName={classes.inline}>
          <TextField source='name' formClassName={classes.inline} />
        </ReferenceField>
        <CheckboxGroupInput
          formClassName={classes.margin}
          source='weekDays'
          choices={[
            {id: '0', name: 'Sunday'},
            {id: '1', name: 'Monday'},
            {id: '2', name: 'Tuesday'},
            {id: '3', name: 'Wednesday'},
            {id: '4', name: 'Thursday'},
            {id: '5', name: 'Friday'},
            {id: '6', name: 'Saturday'},
          ]}
        />
        <TextInput
          source='reason'
          multiline
          resettable
          fullWidth
          validate={validateDescription}
          formClassName={classes.margin}
        />
        <DateInput
          source='startDate'
          formClassName={classes.inline}
          validate={required()}
        />
        <DateInput
          source='endDate'
          formClassName={classes.inline}
          validate={required()}
        />
        <TimeInput
          source='from'
          name='from'
          formClassName={classes.inline}
          validate={required()}
        />
        <TimeInput
          source='to'
          name='to'
          formClassName={classes.inline}
          validate={required()}
        />
      </SimpleForm>
    </Edit>
  );
};
export default UnavailabilityEdit;
